let UnlockIslandRedirector = xClass("UnlockIslandRedirector", BaseRedirector)
UnlockIslandRedirector.prototype.getName = function () {
    return "island_unlock"
}
UnlockIslandRedirector.prototype.redirect = function () {
    let param = this.param;

    console.log("redirect start");

    let um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }

    //  检查是否为点自己的链接
    let uid = um.uid;
    let inviteCode = param["inviteCode"] == null? null: +param["inviteCode"];
    let isMythis = inviteCode === uid || false;
    if (isMythis) {
        Toast.make(getText("coin.match.share.self"));
        return true;
    }

    //  检查子类型
    let shareType = param["subType"];
    if (!shareType) {
        console.log("缺少子类型");
        return true;
    }

    let needCheckNewUser = true;
    let shareId;

    //  根据子类型做不同的解析
    let http = null;
    switch(shareType) {
        case "islanspdup_share":{
            //  岛屿解锁加速分享
            console.log("islandUnlock", " 岛屿解锁加速分享");
            needCheckNewUser = false;
            http = ClickIslandUnlockShareTimeHttp.new();
            break;
        }
        case "islandunlock_share":{
            //  岛屿解锁好友帮助分享
            console.log("islandUnlock", " 岛屿解锁好友帮助分享");
            http = IslandUnlockClickShareHttp.new();
            shareId = param["shareId"] || "";
            break;
        }
        case "islandunlock_share_openData":{
            //  岛屿解锁好友帮助分享（开放域互动分享）
            console.log("islandUnlock", "islandUnlcokOpenDataRedirector run");
            if (_G.kIsNewUser && !_G.isGetNewUserReward) {
                if(SnsProxy.getInstance().allowInteractiveInvite()) {
                    window.OpenContextUtil.postMessage({
                        command: "islandunlock",
                        type: "onRedirector",
                        data: {
                            openid: META.user.openid,
                            time: Localhost.time()
                        }
                    });
                    _G.isGetNewUserReward = true;
                }
            }
            return true;
        }
        case "upgrade":{
            //  岛屿解锁成功后的分享
            console.log("islandUnlock", " 岛屿解锁成功后的分享");
            http = IslandSuccClickShareHttp.new();
            shareId = param["shareId"] || "";
            break;
        }
        default:{
            console.log("分享子类型错误：" + shareType);
            return true;
        }
    }

    //  检查是否为新玩家
    if (needCheckNewUser) {
        if (!_G.kIsNewUser) {
            console.log("不是新玩家");
            return true;
        } else if (_G.isGetNewUserReward) {
            console.log("大哥你别想着刷奖了");
            return true;
        } else {
            console.log("是新玩家");
        } 
    }

    //  向服务端发送回执
    return new Promise((resolve, reject)=> {        
        http && http.addEventListener(Events.kComplete, function (evt) {
            console.log("帮助好友成功");
            _G.isGetNewUserReward = true;
            resolve(evt.data)
        })
        http && http.addEventListener(Events.kError, function (evt) {
            Toast.make(quickGetErrorText(evt.data), 1, function () {})
            console.log("帮助好友失败");
            reject(evt.data)
        })
        http && http.addEventListener(Events.kCancel, function (evt) {
            Toast.make(quickGetErrorText(evt.data), 1, function () {})
            console.log("帮助好友失败");
            reject(evt.data)
        })
        http && http.load(inviteCode, shareId);
    });
}

UnlockIslandRedirector.prototype.hasHighPriorityAction = function () {
    return false;
}

module.exports = UnlockIslandRedirector